// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"130":"fdd72c649b10e524","362":"d79b8995c547d7f1","547":"cd78fd51c7171f1a","737":"bfddaf4870fcf4a8","821":"616723b2ddd3575b"}[chunkId] + ".js";
};